import initAxios from "./initAxios";

class DocsApi {
  constructor(baseUrl) {
    this.apiUrl = baseUrl;
    this.axios = initAxios({
      baseURL: `https://d.${baseUrl}`,
      withCredentials: true,
    });
  }

  getCounters = () =>
    this.axios.get("/api/4.0/documents/directories_counters/");
}

export default DocsApi;
